import React, {useState, useEffect} from 'react';
import { Container, Nav, Dropdown, Navbar, Button } from 'react-bootstrap';
import {Connection} from '@solana/web3.js'
import {ThemeConfig, writeDarkSwitch} from 'bootstrap-darkmode';
import { TOKENS } from "../constants/constants"
import {
    useWallet
} from '@solana/wallet-adapter-react';
import { useAppSelector, useAppDispatch } from '../hooks'
import {
    WalletDisconnectButton
} from '@solana/wallet-adapter-react-ui';
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import { getTokenBalance } from "../redux/tokenAction"
import {setWallet, setSolBalance, toggleSound, toggleDarkMode, toggleUserAnalytics, toggleHistoricalAnalytics, setMode, setTokenBalances} from '../redux/reducers/storageSlice'
const LAMPORTS_PER_SOL = 1000000000

const Header: React.FC = () => {

    const dispatch = useAppDispatch();
    const solBalance = useAppSelector(state => state.storage.solBalance)
    const mode = useAppSelector(state => state.storage.mode)
    const darkmode = useAppSelector(state => state.storage.darkmode)
    const sound = useAppSelector(state => state.storage.sound)
    const connection = new Connection(process.env.REACT_APP_RPC_URL, "confirmed");
    const walletConnected = useAppSelector((state) => state.storage.wallet)
    const [solTPS, setSolTPS] = useState(0)
    let walletAddress = "";
    let timer
    const wallet = useWallet();

    useEffect(() => {
        updateTPS()
        getSolBalance()
        if (!wallet.connected) {
            dispatch(setWallet(null))
            dispatch(setSolBalance(0))
        };
        return () => clearInterval(timer)
    }, [walletConnected, wallet])
    const getSolBalance = async () => {
        if (wallet.connected && wallet.publicKey) {
            walletAddress = wallet.publicKey.toString()
            const SOL = connection.getAccountInfo(wallet.publicKey)
            SOL.then((res) => {
                let lamps = 0
                if (res && res["lamports"]) lamps = res["lamports"]
                let solBal = lamps / LAMPORTS_PER_SOL
                // console.log(solBal)
                dispatch(setWallet(walletAddress))
                dispatch(setSolBalance(solBal.toFixed(4)))
            })      
        } else {
            dispatch(setWallet(null))
        }
    }


    const disconnectWallet = async () => {
        await wallet.disconnect()
    }

    const toggleDark = () => {
        dispatch(toggleDarkMode())
    }

    const updateTPS = () => {
        timer = !timer && setInterval( async () => {
            await getTPS()
            await getTokenBalances()
            // console.log("getting tps")
        }, 5000)
    }

    const changeSound = () => {
        let newSound = true
        if (sound) newSound = false
        dispatch(toggleSound(newSound))
    }

    const getTPS = async () => {
      let medianNumTx = 0;
      let getPerformanceSamples = await connection
        .getRecentPerformanceSamples()
        .then((res) => {
          return res;
        });
      for (let i = 0; i < getPerformanceSamples.length; i++) {
        medianNumTx = medianNumTx + getPerformanceSamples[i].numTransactions;
      }
      medianNumTx = medianNumTx / getPerformanceSamples.length;
      let solTPS = getPerformanceSamples[0].numTransactions / getPerformanceSamples[0].samplePeriodSecs;
      setSolTPS(Math.floor(solTPS))
    }

    const getTokenBalances = async () => {
        if (walletConnected){
            // console.log('getting token balances')
            let tokens = Object.keys(TOKENS)
            let dispatchedTokenBalances = {}
            for (var i = 0; i < tokens.length; i++){
                let curToken = tokens[i]
                let tokenBal = await getTokenBalance(curToken, wallet)
                dispatchedTokenBalances[curToken] = tokenBal
            }
            dispatch(setTokenBalances(dispatchedTokenBalances))  
        }

        
    }

    return (
        <Navbar  style={{}} expand="lg">
            <div style={{display: "none", position: "fixed", top: 0, textAlign: "center", width: "100%", backgroundColor: 'rgba(220, 53, 69, 0.4)', height: 25, zIndex:1000}}>
                <p><span style={{fontWeight: "bold", fontSize: 12, color: "purple"}}>SOLANA TPS: </span><span style={{fontWeight: "bold", fontSize: 12, color: "black"}}>{solTPS}</span></p>
            </div>        
          <Container>

            <Navbar.Brand href="#home"><img alt="not found" src="/images/logo.png" width={150}/></Navbar.Brand>
                <Navbar.Text style={{lineHeight: "14px"}}>
                     <span style={{fontWeight: "bold", fontSize: 12, color: "purple"}}>SOLANA TPS</span>
                     <br/>
                     <span style={{fontWeight: "bold", fontSize: 12, color: "white"}}>{solTPS}</span>
                </Navbar.Text>            
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav" className="justify-content-end">

                <Nav>
                    <Navbar.Text style={{display: "flex", margin: 3}}>
                         <span style={{fontWeight: "bold", fontSize: 20, color: "white"}}>{solBalance}</span>
                         <span style={{marginLeft: 5}}><img alt="not found" src={"https://multiflip.io/images/SOL.png"} height={20} /></span>
                    </Navbar.Text>                 
                    <Nav style={{margin: "7px"}}>
                         {wallet.connected ? 
                            <Dropdown>
                              <Dropdown.Toggle className="stats" variant="light" id="dropdown-basic">
                                <i style={{color: "black"}}className="lni lni-bar-chart"></i>
                              </Dropdown.Toggle>

                              <Dropdown.Menu>
                                <Dropdown.Item href="https://mixpanel.com/p/BcHjszG5rVhmjiYGCoEQJc" target="_blank" rel="noopener noreferrer">7 Days</Dropdown.Item>
                                <Dropdown.Item href="https://mixpanel.com/p/EWQW63GnwdqNSgxGuCge6c" target="_blank" rel="noopener noreferrer">Degen: 7 Days</Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>                        

                            : 
                            null
                        }
                    </Nav>            
                    <Nav.Link eventKey="link-2">
                         {
                            wallet.connected ? 
                                <Button  style={{marginTop: "-1px"}} className="stats" variant="light" onClick={() => dispatch(toggleUserAnalytics())}>
                                    <i style={{color: "black"}}className="lni lni-user"></i>
                                 </Button>
                            :
                            null
                        }
                    </Nav.Link>           
                    <Nav.Link eventKey="link-2">
                         {
                            wallet.connected ? 
                                <Button  style={{marginTop: "-1px"}} className="stats" variant="light" onClick={() => dispatch(toggleHistoricalAnalytics())}>
                                    <i style={{color: "black"}}className="lni lni-graph"></i>
                                 </Button>
                            :
                            null
                        }
                    </Nav.Link>                                                                  
                    {wallet.connected && <WalletDisconnectButton onClick={() => disconnectWallet()} style={{margin: 7}}/>}
                    <Nav.Link eventKey="link-3">
                         {
                            wallet.connected ? <Button  style={{marginTop: "-1px"}} className="stats" variant="light" onClick={() => changeSound()}>
                                {
                                    sound ? <i style={{color: "black"}}className="lni lni-volume-high"></i> : <i style={{color: "black"}}className="lni lni-volume-mute"></i>
                                }
                             </Button>
                            :
                            null
                        }
                    </Nav.Link>

                 
                  </Nav>

                
              
            </Navbar.Collapse>
          </Container>
        </Navbar>
    );
};

export default Header;